import React from 'react';
import styles from './ContextTitle.module.less';

type ContextTitleType = {
  title: string | React.ReactNode;
  desc?: string | React.ReactNode;
  style?: React.CSSProperties;
};

export const ContextTitle = ({ title, desc = '', style = {} }: ContextTitleType) => {
  return (
    <div className={styles.contextTitle} style={style}>
      <div className={styles.title}>{title}</div>
      {desc ? <div className={styles.desc}>{desc}</div> : null}
    </div>
  );
};
